import * as angular from "angular";
import {IHttpService, IQService} from "angular";
import {ApiConfig} from "../../commons/models/api-config.model";

export class PoliciesRequestsService {

  /* @ngInject */
  constructor(private apiConfig: ApiConfig, private $http: IHttpService, private $q: IQService) {

  }

  // ******************************
  // External methods
  // ******************************

  editUserBindings(policyId, userId, bindings: { roleId?: string[], rolesGroupId?: string[] }[], orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.post(`${baseUrl}/${policyId}/users/${userId}/roles`,
      {bindings: bindings},
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  getUserReports(policyId, userId, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.get(`${baseUrl}/${policyId}/users/${userId}/notifications`,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  editUserReports(policyId, userId, payload, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.post(`${baseUrl}/${policyId}/users/${userId}/notifications`,
      payload,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  addNewUser(policyId, user, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    const deferred = this.$q.defer();
    this.$http.put(baseUrl + '/' + policyId + '/users',
      user,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        deferred.resolve(res.data);
      })
      .catch((error) => {
        deferred.reject(error);
      });

    return deferred.promise;
  }

  deleteUser(policyId, userId, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    const deferred = this.$q.defer();
    this.$http.delete(baseUrl + '/' + policyId + '/users/' + userId,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        deferred.resolve(res.data);
      })
      .catch((error) => {
        deferred.reject(error);
      });

    return deferred.promise;
  }

  addNewServiceAccount(policyId, user, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.put(baseUrl + '/' + policyId + '/serviceAccounts',
      user,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  updateServiceAccount(policyId, serviceAccountId, bindings, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    // return this.$http.post(baseUrl + '/' + policyId + '/serviceAccounts/' + serviceAccountId,
    return this.$http.post(`${baseUrl}/${policyId}/serviceAccounts/${serviceAccountId}/roles`,
      bindings,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  deleteServiceAccount(policyId, serviceAccountId, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.delete(baseUrl + '/' + policyId + '/serviceAccounts/' + serviceAccountId,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  updatePasswordPolicy(policyId, passwordPolicy, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.post(baseUrl + '/' + policyId + '/password',
      passwordPolicy,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  updateTokenPolicy(policyId, tokenPolicy, orgId, siteId) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.post(baseUrl + '/' + policyId + '/token',
      tokenPolicy,
      {
        params: {
          orgId: orgId,
          siteId: siteId
        }
      })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  editUserPolicyGroup(policyId, userId, siteId, groupIds: string[]) {
    const deferred = this.$q.defer();

    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    this.$http.post(baseUrl + '/' + policyId + '/users/' + userId + '/group', {groupIds: groupIds}, {
      params: {
        siteId: siteId
      }
    })
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      });

    return deferred.promise;
  }

  removeUserPolicyBranchesAndGroups(policyId, userId, siteId, branchIds?: string[], groupIds?: string[]) {
    const deferred = this.$q.defer();

    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    this.$http.post(baseUrl + '/' + policyId + '/users/' + userId + '/removeBranchesAndGroups', {branchIds: branchIds, groupIds: groupIds}, {
      params: {
        siteId: siteId
      }
    })
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      });

    return deferred.promise;
  }


  getAllRolesGroups(policyId: string, orgId?: string, siteId?: string) {
    const deferred = this.$q.defer();

    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    this.$http.get(baseUrl + '/' + policyId + '/rolesGroup', {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((res) => {
        deferred.resolve(res.data);
      })
      .catch((error) => {
        deferred.reject(error)
      });

    return deferred.promise;
  }

  createRolesGroup(group, policyId, orgId?: string, siteId?: string) {
    const deferred = this.$q.defer();

    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    this.$http.put(baseUrl + '/' + policyId + '/rolesGroup', group, {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      });

    return deferred.promise;
  }

  deleteRolesGroup(groupId, policyId, orgId?: string, siteId?: string) {
    const deferred = this.$q.defer();

    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    this.$http.delete(baseUrl + '/' + policyId + '/rolesGroup/' + groupId, {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      });

    return deferred.promise;
  }

  editRolesGroup(payload, groupId, policyId, orgId?: string, siteId?: string) {
    const deferred = this.$q.defer();

    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    this.$http.post(baseUrl + '/' + policyId + '/rolesGroup/' + groupId, payload, {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((res) => {
        deferred.resolve(res);
      })
      .catch((error) => {
        deferred.reject(error)
      });

    return deferred.promise;
  }

  addMembersToGroup(groupId, policyId, userIds, orgId?: string, siteId?: string) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.post(baseUrl + '/' + policyId + '/rolesGroup/' + groupId + '/members/add', userIds, {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }

  removeMembersFromGroup(groupId, policyId, userIds, orgId?: string, siteId?: string) {
    const baseUrl = this.apiConfig.baseUrl + `/policies`;
    return this.$http.post(baseUrl + '/' + policyId + '/rolesGroup/' + groupId + '/members/remove', userIds, {
      params: {
        orgId: orgId,
        siteId: siteId
      }
    })
      .then((res) => {
        return this._sendResponseData(res)
      })
      .catch((error) => {
        return this._sendError(error)
      });
  }


  // ******************************
  // Internal methods
  // ******************************

  _sendResponseData(response) {
    return this.$q.when(response.data);
  }

  _sendError(response) {
    return this.$q.reject(response.data);
  }

}

angular
  .module('bringoz.admin.policies')
  .service('policiesRequestsService', PoliciesRequestsService);
